import MuiTooltip, { TooltipProps } from '@mui/material/Tooltip';
import type { Modifier } from '@popperjs/core';

import { useWindowedTooltipZIndex } from '../dialog/windowed-tooltip-zindex-context';

const Tooltip = ({ slotProps, ...props }: TooltipProps) => {
  const windowedConfig = useWindowedTooltipZIndex();

  return (
    <MuiTooltip
      {...props}
      slotProps={
        windowedConfig === undefined
          ? slotProps
          : {
              ...slotProps,
              popper: {
                ...slotProps?.popper,
                sx: {
                  zIndex: windowedConfig.zIndex,
                  ...(slotProps?.popper as { sx?: object } | undefined)?.sx,
                },
                modifiers: [
                  ...(windowedConfig.boundaryElement
                    ? ([
                        {
                          name: 'preventOverflow',
                          options: { boundary: windowedConfig.boundaryElement },
                        },
                        {
                          name: 'flip',
                          options: { boundary: windowedConfig.boundaryElement },
                        },
                      ] as Partial<Modifier<string, Record<string, unknown>>>[])
                    : []),
                  ...((
                    slotProps?.popper as
                      | {
                          modifiers?: Partial<
                            Modifier<string, Record<string, unknown>>
                          >[];
                        }
                      | undefined
                  )?.modifiers ?? []),
                ],
              },
            }
      }
    />
  );
};

export { Tooltip };
